import { TagCreate } from './TagCreate'
import { TagEdit } from './TagEdit'
import { TagList } from './TagList'
import { TagShow } from './TagShow'

export { TagCreate, TagEdit, TagList, TagShow }
